var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Log out"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.5538 17.1359V18.4402C15.5538 19.5208 14.6778 20.3967 13.5973 20.3967H7.04295C5.96239 20.3967 5.08643 19.5208 5.08643 18.4402V6.96195C5.08643 5.8814 5.96239 5.00543 7.04295 5.00543H13.5973C14.6778 5.00543 15.5538 5.8814 15.5538 6.96195V8.2663M20.3147 12.7337H11.4777M18.7305 14.8859L20.1909 13.4254C20.573 13.0434 20.573 12.424 20.1909 12.042L18.7305 10.5815",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/LogOut.50f9aff41fc4f5cab5cbd7223a3c88c4.svg";
export { ForwardRef as ReactComponent };